interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  onChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    pages.push(i);
  }

  const baseBtn =
    "flex h-10 w-10 items-center justify-center rounded-md border text-sm font-label transition-colors cursor-pointer";
  const idle = "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600";
  const active = "border-primary-500 bg-primary-500 text-background-50";
  const disabled = "border-background-200 bg-background-50 text-foreground-300 cursor-not-allowed";

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        className={`${baseBtn} ${currentPage === 1 ? disabled : idle}`}
        onClick={() => currentPage > 1 && onChange(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          className={`${baseBtn} ${page === currentPage ? active : idle}`}
          onClick={() => onChange(page)}
          aria-current={page === currentPage ? "page" : undefined}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        className={`${baseBtn} ${currentPage === totalPages ? disabled : idle}`}
        onClick={() => currentPage < totalPages && onChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}